export function loadSvg(url) {
  return fetch(url).then(response => {
    if (!response.ok) {
      throw new Error(`Failed to fetch image from ${url}`);
    }

    return response.text();
  });
}
